<template>
  <!--新面单尺寸 类样式不生效 需要写行内样式-->
  <div style="width: 300px; height: 0; overflow: hidden">
    <div
      id="LodopPrintTemplate-info"
      style="width: 265px; padding-left: 8px"
    >
      <div style="font-size: 20px; text-align: center; letter-spacing: 10px">
        一手退换货包裹
      </div>
      <div style="padding: 10px" />
      <div style="display: flex">
        <div>
          <qrcode-vue
            :key="info.package.package_no"
            :value="info.package.package_no"
            :size="100"
            level="H"
            render-as="svg"
          />
        </div>
        <div style="display: flex; flex-direction: column; margin-left: 8px">
          <div style="font-size: 13px; line-height: 24px; padding: 4px 0">
            市场: {{ info.package.parent_market_name }}
          </div>
          <div style="font-size: 13px; line-height: 24px; padding: 4px 0">
            子市场: {{ info.package.market_name }}
          </div>
          <div style="font-size: 13px; line-height: 24px; padding: 4px 0">
            代采组: {{ info.package.pg_name }}
          </div>
        </div>
      </div>
      <!-- <div style="padding: 8px" /> -->
      <div style="font-size: 13px; line-height: 24px; padding: 6px 0">
        包裹单号: {{ info.package.package_no }}
      </div>
      <div style="font-size: 14px; line-height: 24px; padding: 6px 0">
        商品数量：<span style="font-weight: bold">{{
          info.package.total
        }}</span>
      </div>
      <div style="font-size: 16px; line-height: 24px; padding: 6px 0">
        商家名称：{{ info.package.supply_name }}
      </div>
      <div style="font-size: 16px; line-height: 24px; padding: 6px 0">
        换货专员：{{ info.package.dg_member_name }}
      </div>
      <div style="font-size: 16px; line-height: 24px; padding: 6px 0">
        商家收货地址：
        <div style="font-size: 14px">{{ info.package.address }}</div>
      </div>
      <img
        :src="
          'https://erp.yishouapp.com/barcode.php?text=' +
          info.package.package_no
        "
        style="
          display: block;
          width: 240px;
          text-align: center;
          height: 100px;
          margin: 0 auto;
        "
        alt=""
      />
      <div style="font-size: 16px; line-height: 24px; padding: 6px 0">
        分播方案：{{info.case_name}} ，格口号：{{info.grid_no}}
      </div>
    </div>

    <div style="padding: 130px" />
    <div id="LodopPrintTemplate-list" style="width: 280px">
      <div
        style="
          font-size: 18px;
          text-align: left;
          letter-spacing: 2px;
          margin-bottom: 20px;
        "
      >
        退换货出库商品明细
      </div>
      <div style="font-size: 13px; line-height: 24px; padding: 6px 0">
        包裹单号: {{ info.package.package_no }}
      </div>
      <div style="font-size: 14px; line-height: 24px; padding: 6px 0">
        商品数量：<span style="font-weight: bold">{{
          info.package.total
        }}</span>
      </div>
      <div style="font-size: 16px; line-height: 24px; padding: 6px 0">
        商家名称：{{ info.package.supply_name }}
      </div>
      <div style="font-size: 14px; line-height: 24px; padding: 6px 0">
        校验打包时间： {{ info.package.pack_datetime }}
      </div>
      <div style="font-size: 16px; line-height: 24px; padding: 6px 0">
        分播方案：{{info.case_name}} ，格口号：{{info.grid_no}}
      </div>
      <div style="font-size: 14px; line-height: 24px; padding: 6px 0">
        打包清单：
      </div>
      <table style="width: 100%; border-collapse: collapse">
        <thead>
          <tr>
            <th
              style="padding: 5px; text-align: center; border: 1px solid #ccc"
            >
              款号
            </th>
            <th
              style="padding: 5px; text-align: center; border: 1px solid #ccc"
            >
              颜色
            </th>
            <th
              style="padding: 5px; text-align: center; border: 1px solid #ccc"
            >
              尺码
            </th>
            <th
              style="padding: 5px; text-align: center; border: 1px solid #ccc"
            >
              数量
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in info.phd.detail" :key="index">
            <td
              style="padding: 5px; text-align: center; border: 1px solid #ccc"
            >
              {{ item.goods_kh }}
            </td>
            <td
              style="padding: 5px; text-align: center; border: 1px solid #ccc"
            >
              {{ item.co_val }}
            </td>
            <td
              style="padding: 5px; text-align: center; border: 1px solid #ccc"
            >
              {{ item.si_val }}
            </td>
            <td
              style="padding: 5px; text-align: center; border: 1px solid #ccc"
            >
              {{ item.number }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="padding: 130px" />
    <div
      id="LodopPrintTemplate-error"
      style="width: 265px; padding-left: 8px"
    >
      <div style="font-size: 16px; line-height: 24px; padding: 6px 0">
        <div>分播方案：{{info.case_name}} </div>
        <div>格口号：{{info.grid_no}}</div>
      </div>
      <div style="font-size: 16px; line-height: 24px; padding: 40px 0">
        {{info.msg}}
      </div>
    </div>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import commonLodopPrint from '@/utils/lodopPrint.js';

export default {
  name: "LodopPrintTemplate",
  components: {
    QrcodeVue,
  },
  data() {
    return {
      info: {
        package: {
          package_no: "",
          total: "",
          pack_datetime: "",
          supply_name: "",
          address: "",
          dg_member_name: "",
          parent_market_name: "",
          market_name: "",
          pg_name: "",
          printer: ""
        },
        phd: {
          package: {},
          detail: []
        },
        remark: "",
        result: true,
      }
    }
  },
  methods: {
    calling() {
      this.$nextTick(() => {
        console.log(this.info);
        if(this.info.result){
          this.print("LodopPrintTemplate-info", this.info.package.printer);
          this.print("LodopPrintTemplate-list", this.info.phd.package.printer);
        } else {
          this.print("LodopPrintTemplate-error", this.info.printer);
        }
      });
    },
    print(id, PRINTER_INDEX) {
      const element = document.getElementById(id);
      console.log(PRINTER_INDEX, id, element);
      if (!element) {
        console.error('print Element error:', error);
        return;
      }
      try {
        commonLodopPrint(id, PRINTER_INDEX);
      } catch (error) {
        console.error('LodopPrintTemplate print error:', error);
      }
    },
    /**
     * Execute a print job
     * @param {Object} printJob
     * @returns {Promise<boolean>} - Success status
     */
     async executePrint(printJob) {
      try {
        // Update the component's data
        this.info = printJob;
        
        // Wait for the template to update
        await this.$nextTick();
        
        // Prepare the template
        this.calling();
        
        // Return success - the actual printing will be handled by the parent
        return true;
      } catch (error) {
        console.error('Print execution error:', error);
        return false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/machine/components/LodopPrintTemplate.vue